var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeSearch',{attrs:{"id":"home"}}),_c('RealDescription'),_c('Articles',{attrs:{"id":"articles"}}),_c('BrowseBrands'),_c('UserQuotes'),_c('DownloadReal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }